// helper function to have a console.trace that is collapsed
// by default

export default (ident, ...args) => {
  console.groupCollapsed(ident)
  console.trace(...args)
  console.groupEnd(ident)
}
